<template>
  <div>
    <div>
      <customer
        :name="customer.name ? customer.name : newCustomer.name"
        :phone="Utils.phoneMask(customer.phone)"
        :birthday="customer.birthdate ? Utils.db2date(customer.birthdate) : ''"
        :email="customer.email || ''"
      />

      <base-card
        v-if="!!this.annotation && !!this.annotation.id"
        class="notes-card"
      >
        <p class="notes-title">Anotações</p>
        <p class="notes-text p_0">{{ this.annotation.annotation }}</p>
      </base-card>

      <base-card
        v-for="(address, addressIndex) in customer.addresses"
        :key="addressIndex"
        class="relative"
      >
        <div class="info-customer-address d-flex align-center">
          <p class="mr_20 fs-12 o-50">
            <i class="fal fa-map-marker-alt"></i>
          </p>
          <div class="w-100">
            <p class="w-100">{{ formatAddressString(address) }}</p>
            <div class="address-datas">
              <span>{{ distanceTo(address.geolocation) }}</span>
              <span>{{ deliveryTax(address.geolocation) }}</span>
            </div>
          </div>
        </div>
      </base-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BaseCard from "@/components/Card";

import Utils from "@/utils";
import AccountApi from "@/api/account";
import UserApi from "@/api/user";
import CustomerApi from "@/api/customer";

import Customer from "@/containers/Customer";
import Location from "@/plugins/core/schema/configurations/BasicInfo/Location";
import Geolocation from "easyjs/lib/Schema/Address/Geolocation";
import Delivery from "easyjs/lib/Schema/Delivery/index";

export default {
  props: {
    configurations: {},
    role: {},
    customer: {},
  },
  data() {
    return {
      Location,
      Utils,
      newCustomer: {},
      addresses: [],
      annotation: { annotation: null },
      lastScheduledSearch: [],
      addressString: [],
      addressOptions: [],
    };
  },
  components: {
    BaseCard,
    Customer,
  },
  mounted() {
    this.newCustomer = JSON.parse(JSON.stringify(this.customer));
    if (this.newCustomer.birthdate) {
      this.newCustomer.birthdate = Utils.db2date(this.newCustomer.birthdate);
    }

    this.addresses = this.customer.addresses
      ? Object.clone(this.customer.addresses)
      : [];
    this.annotation = this.customer.annotation
      ? Object.clone(this.customer.annotation)
      : { annotation: null };
  },
  methods: {
    distanceTo(addressGeolocation) {
      if (!addressGeolocation) {
        return " - ";
      }

      let restaurantGeo = Geolocation.fromObject(
        this.configurations.location.geolocation
      );
      if (
        restaurantGeo.latitude == addressGeolocation.latitude &&
        restaurantGeo.longitude == addressGeolocation.longitude
      ) {
        return Utils.convertMoney(0, "", "Km");
      }

      return Utils.convertMoney(
        restaurantGeo.distanceTo(addressGeolocation) / 1000,
        "",
        "Km"
      );
    },
    deliveryTax(addressGeolocation) {
      if (!addressGeolocation) {
        return " - ";
      }

      const restaurantGeo = Geolocation.fromObject(
        this.configurations.location.geolocation
      );
      const samePlace =
        restaurantGeo.latitude == addressGeolocation.latitude &&
        restaurantGeo.longitude == addressGeolocation.longitude;
      const distance = samePlace
        ? 0
        : restaurantGeo.distanceTo(addressGeolocation) / 1000;

      let deliveryRegions = this.configurations.delivery_region;
      let radiusStrips = deliveryRegions.filter(
        (region) => +region.up_to >= +distance
      );

      radiusStrips.sort((a, b) => +a.up_to <= +b.up_to);

      if (radiusStrips[0] && !!radiusStrips[0].free_fee) {
        return "Taxa grátis";
      }

      return radiusStrips[0]
        ? Utils.convertMoney(+radiusStrips[0].price)
        : "Fora da região de entrega";
    },
    formatAddressString(location, inverseNumber = false) {
      let addressString = `${location.address}${
        location.number !== "null" ? `, ${location.number}` : ""
      }`;

      if (inverseNumber) {
        addressString = `${location.number ? `${location.number}, ` : ""}${
          location.address
        }`;
      }

      if (location.complement) {
        addressString += `, (${location.complement})`;
      }

      if (location.region || location.city) {
        addressString += ` - ${
          location.region
            ? `${location.region}${location.city ? `, ${location.city}` : ""}`
            : `${location.city}`
        }`;
      }

      if (location.state || location.country) {
        addressString += ` - ${
          location.state
            ? `${location.state}${
                location.country ? `, ${location.country}` : ""
              }`
            : `${location.country}`
        }`;
      }

      if (location.zipcode) {
        addressString += ` - ${location.zipcode}`;
      }

      if (location.observation) {
        addressString += ` - (${location.observation})`;
      }

      return addressString;
    },
    onAddressSelected(option, index) {
      if (option.address) {
        this.addresses[index] = Location.fromObject(option.address);
        this.$forceUpdate();
      }
    },
    updateAddress(index) {
      let searchAddress = this.addresses[index];

      if (!searchAddress.number) {
        return alert("Número não informado!");
      }

      Vue.set(this.addresses, index, Location.fromObject(searchAddress));
    },
  },
  watch: {
    customer: {
      deep: true,
      handler(newValue) {
        if (newValue.id) {
          this.newCustomer.id = newValue.id;
        }

        Vue.set(this, "addresses", Object.clone(newValue.addresses || []));
        Vue.set(
          this,
          "annotation",
          Object.clone(newValue.annotation || { annotation: null })
        );
      },
    },
  },
};
</script>

<style scoped>
.info-customer-address,
.notes-text {
  font-size: 1.4em;
  color: #8C8C8C;
}

.info-customer-address i {
  font-size: 21px;
}

.info-customer-address p:first-child {
  color: #AAAAAB;
  line-height: 15px;
}

.delete-address {
  position: absolute;
  top: 22px;
  right: 17px;
  font-size: 1.4em;
  color: var(--default);
}

.address-datas {
  margin-top: 20px;
  color: #AAAAAB;
  display: flex;
}

.address-datas span {
  background: var(--box-up);
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  font-weight: bold;
}

.notes-title {
  font-size: 1.4em;
  color: #999999;
  font-weight: bold;
  margin-bottom: 15px;
}

.field-title {
  font-weight: 600;
  font-size: 1.3em;
  margin-bottom: 7px;
}

.field-title + p {
  font-size: 1.3em;
  color: #bbb;
}
</style>
